import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, finalize, takeUntil, tap } from 'rxjs';

import {
  CustomResultOfPaginatedListOfGetOrganizationBlackListExceptionsByOrganizationIdWithPaginationDto,
  GetOrganizationBlackListExceptionsByOrganizationIdWithPaginationDto,
} from 'src/app/core/api/models';
import { OrganizationBlackListExceptionsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { AppDomService } from 'src/app/core/services/dom.service';
import { BaseIndexModule } from 'src/app/pages/shared/base';
import { BaseIndexPageComponent } from 'src/app/pages/shared/base/components/base-index-page.component';
import { OrganizationsBlackListExceptionsFormComponent } from './organizations-black-list-exceptions-form/organizations-black-list-exceptions-form.component';

@Component({
    selector: 'app-organizations-black-list-exceptions',
    templateUrl: './organizations-black-list-exceptions.component.html',
    imports: [BaseIndexModule]
})
export class organizationsBlackListExceptionsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  pageName = 'organizationsBlackListExceptions';
  @Input() organizationId: any;

  items$: Observable<
    Array<GetOrganizationBlackListExceptionsByOrganizationIdWithPaginationDto>
  >;
  idPropertyName = 'mobile';

  @Output('onBack') output_onBack = new EventEmitter<boolean>();

  constructor(
    protected currentService: OrganizationBlackListExceptionsService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();

    this.pageConfig.title = 'common.organizationsBlackListExceptions';
    this.pageConfig.showAuditBtn = false;
    this.pageConfig.showHelpBtn = false;
    this.pageConfig.showRefreshBtn = true;
    this.pageConfig.tableConfig.showOperationColumn = false;
    this.pageConfig.isAddBtnWithLoading = false;
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: ``,
        name: '',
        hasSearch: false,
        noSorting: true,
        isCheckBox: true,
      },
      {
        title: this.localizer.mobile,
        name: 'mobile',
        hasSearch: true,
      },
      {
        title: this.localizer.createDate,
        name: 'createdAt',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  setDefaultTableSort() {
    try {
      //اگر از قبل مقدار وجود داشت دیگه push نکنه
      const isExistsSortObject = this.sortObject.some((item) =>
        item.columnName.includes('createdAt')
      );
      if (!isExistsSortObject)
        this.sortObject.push({ columnName: 'createdAt', sort: 1 });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  //#region api
  //Get All
  getPaginationApi(): Observable<CustomResultOfPaginatedListOfGetOrganizationBlackListExceptionsByOrganizationIdWithPaginationDto> {
    return this.currentService.organizationBlackListExceptionsGetOrganizationBlackListExceptionsWithPagination(
      {
        body: {
          ...this.getBaseModelWithPaginationParams(),
          organizationId: this.organizationId,
        },
      }
    );
  }

  deleteBlackListExceptionsApi(mobiles: string[]) {
    this.unSubs();

    this.pageConfig.loading = true;
    this.lastSelectedItemId = mobiles;

    this.currentService
      .organizationBlackListExceptionsDelete({
        body: { organizationId: this.organizationId, mobiles: mobiles },
      })
      .pipe(
        this.basePipeOperators(),
        finalize(() => (this.selectedIds = []))
      )
      .subscribe(this.baseGroupDeleteObserver);
  }

  //#endregion

  onCreate() {
    this.unSubs();

    let data = {
      title: `${this.formPageConfig?.vocabs}addTitle`,
      isEdit: false,
      organizationId: this.organizationId,
    };

    const modalResult = this.dialogService.openModal({
      component: OrganizationsBlackListExceptionsFormComponent,
      data: data,
    });

    modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => (this.pageConfig.isVisibleForm = undefined)),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe((res) => {
        if (res) {
          this.getTableData();
          this.cd.detectChanges();
        }
      });
  }

  //#region group Deletion
  callGroupDeletion() {
    this.deleteBlackListExceptionsApi(this.selectedIds);
  }

  //#endregion
  emitOnBack() {
    this.output_onBack.emit(true);
    this.unSubs();
  }
}
